import React from "react";
import { emptyStep } from "../FlowControllerTypes";
var FlowControllerContext = /*#__PURE__*/React.createContext({
  steps: [emptyStep],
  currentStep: emptyStep,
  nextStep: function nextStep() {},
  prevStep: function prevStep() {},
  gotoStep: function gotoStep() {}
});
export default FlowControllerContext;